module.exports = __webpack_public_path__ + "img/chr_ts_90_2.27691b78.png";